export default __webpack_public_path__ + "static/media/wall-e.f551e0ac.png";